import { render, staticRenderFns } from "./CreateFromTrainingModule.vue?vue&type=template&id=45e2f3d2&scoped=true&"
import script from "./CreateFromTrainingModule.vue?vue&type=script&lang=ts&"
export * from "./CreateFromTrainingModule.vue?vue&type=script&lang=ts&"
import style0 from "./CreateFromTrainingModule.vue?vue&type=style&index=0&id=45e2f3d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e2f3d2",
  null
  
)

/* custom blocks */
import block0 from "./CreateFromTrainingModule.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports